import DropdownMethodology from "../components/AirportsEfficiencyComponents/DropdownMethodology.js";
import MethodologyText from "../components/AirportsEfficiencyComponents/MethodologyText.js";
import FindingsEfficiencyTab from "../components/AirportsEfficiencyComponents/FindingsEfficiencyTab.js";
import GeneralFindings from "../components/AirportsEfficiencyComponents/GeneralFindings.js";

export default function AirportsEfficiency() {
  return (
    <div className="container page-wrapper">
      <h1>Αποδοτικότητα αεροδρομίων</h1>
      <p style={{ marginTop: "20px" }}>
        Η συνεχής αύξηση της αεροπορικής ζήτησης απαιτεί την ύπαρξη αποδοτικών
        μεταφορών. Είναι αναγκαίο τα αεροδρόμια να λειτουργούν σε συνθήκες καλής
        αποδοτικότητας ώστε να μπορούν να καλύψουν τις ανάγκες της αυξανόμενης
        ζήτησης.
      </p>

      <p>
        Παρακάτω αξιολογούνται τα αεροφρόμια βάσει του δείκτη αποδοτικότητας ανά
        έτος, παράλληλα παρέχεται το εργαλείο εκτίμησης αποδοτικότητας. Με την
        χρήση εισροών της επιλογής σας μποείτε να λάβετε αποττελέσματα σχετικά
        με την αποδοτικότητα των μονάδων λήψης απόφασης της επιλογής σας.
      </p>

      <DropdownMethodology
        buttonText="Μεθοδολογία"
        component={<MethodologyText />}
      />

      <GeneralFindings />
    </div>
  );
}
